import React, { useEffect, useState } from 'react';
import { Empty, Spin, Tag } from 'antd';
import { getPetInfoApi } from '@/api/member/member';
import styles from '../../index.module.scss';

const genderIcons = {
  male: 'https://img.alicdn.com/imgextra/i2/155168396/O1CN01HAwFMz2BtQTGaS9JP_!!155168396.png',
  female: 'https://img.alicdn.com/imgextra/i1/155168396/O1CN01jEsB8R2BtQTGznqOF_!!155168396.png',
};

const defaultAvatars = {
  dog: 'https://img.alicdn.com/imgextra/i3/155168396/O1CN01HvRVMi2BtQTGD5WA9_!!155168396.png',
  cat: 'https://img.alicdn.com/imgextra/i4/155168396/O1CN01SECGfQ2BtQTG6pvz3_!!155168396.png',
};

const pickAvatar = (pet: any) => {
  const src = pet.petImg || pet.petJdImg || pet.petTmImg;
  if (src) return src;
  if (pet.petType === '猫' || pet.petType === '2' || pet.petType === 2) return defaultAvatars.cat;
  return defaultAvatars.dog;
};

const getGenderIcon = (gender: string) => {
  if (!gender) return '';
  const val = gender.toString().toLowerCase();
  if (val.includes('公') || val.includes('male') || val === 'm' || val.includes('雄')) return genderIcons.male;
  if (val.includes('母') || val.includes('female') || val === 'f' || val.includes('雌')) return genderIcons.female;
  return '';
};

const PetInfoTab: React.FC<{ oneId: string; active: boolean }> = ({ oneId, active }) => {
  const [petList, setPetList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    setPetList([]);
    setInitialized(false);
  }, [oneId]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!active || !oneId || initialized) return;
    fetchPetList();
    setInitialized(true);
  }, [active, initialized, oneId]);

  const fetchPetList = async () => {
    setLoading(true);
    try {
      const res = await getPetInfoApi({ oneId });
      if (res?.code === 200) {
        setPetList(res.data || []);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (!petList.length) {
    return (
      <Spin spinning={loading}>
        <Empty description="暂无宠物信息" />
      </Spin>
    );
  }
  return (
    <Spin spinning={loading}>
      <div className={styles['pet-grid']}>
        {petList.map(pet => (
          <div
            key={pet.petOneId || pet.petNickName}
            className={styles['pet-card']}>
            <div className={styles['pet-card__top']}>
              <div className={styles['pet-card__avatar-box']}>
                <img
                  className={styles['pet-card__avatar']}
                  src={pickAvatar(pet)}
                  alt={pet.petNickName || '宠物'}
                />
                {getGenderIcon(pet.gender) && (
                  <img
                    className={styles['pet-card__gender']}
                    src={getGenderIcon(pet.gender)}
                    alt={pet.gender}
                  />
                )}
              </div>
              <div className={styles['pet-card__content']}>
                <div className={styles['pet-card__title-row']}>
                  <div
                    className={styles['pet-card__name']}
                    title={pet.petNickName || ''}>
                    {pet.petNickName || ''}
                  </div>
                  <div
                    className={styles['pet-card__breed']}
                    title={pet.petBreedName || pet.petType || '-'}>
                    {pet.petBreedName || pet.petType || '-'}
                  </div>
                </div>
                <div className={styles['pet-card__age']}>
                  <span>{pet.ageYear || '-'}</span>
                  <span className={styles['pet-card__age-sep']}></span>
                  <span>{pet.petLifeStageName || '-'}</span>
                </div>
                <div className={styles['pet-card__tags']}>
                  {(pet.tagList || []).filter(Boolean).length ? (
                    (pet.tagList || []).filter(Boolean).map((tag: any) => (
                      <Tag
                        className={styles['pet-card__tag-antd']}
                        color="blue"
                        key={tag}>
                        {tag}
                      </Tag>
                    ))
                  ) : (
                    <span className={styles['pet-card__tag-empty']}></span>
                  )}
                </div>
              </div>
            </div>
            <div className={styles['pet-card__divider']}></div>
            <div className={styles['pet-card__footer']}>
              <span className={styles['pet-card__label']}>创建时间：</span>
              <span className={styles['pet-card__value']}>{pet.date || pet.createTime || '-'}</span>
            </div>
          </div>
        ))}
      </div>
    </Spin>
  );
};

export default PetInfoTab;
